import React , { useState,useEffect,useRef }from "react";
import { useDispatch, useSelector } from "react-redux";
import {searchMetrico,getMetricosMenu,changeMetrico,changeMarca, globalData,getMetrico, getData} from '../actions/mainMetrico';

import {Spin,Tooltip,Badge,Rate,Select,Modal,Layout,Menu,Button,Popconfirm,Input,message as messageAntd} from 'antd';
import {LoadingOutlined,SearchOutlined,HomeOutlined,AlertOutlined,DollarCircleOutlined,InfoCircleOutlined,CreditCardOutlined,FireOutlined,ToolOutlined,TagOutlined,CarOutlined,BarChartOutlined,AppstoreOutlined,LineChartOutlined,TableOutlined,LeftOutlined,RightOutlined,UserOutlined,SettingOutlined } from '@ant-design/icons';
import { Switch, Route, NavLink,useHistory,Link,useLocation } from 'react-router-dom';

import Metrico from '../containers/metrico';
import TableMetrico from '../containers/tableMetrico';
import MenuMetricos from '../components/menuMetricos'
import SelectMarcas from '../components/selectMarcas'


const { Search } = Input;
const { Option } = Select;


const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

function MainMetrico(props) {
    
    const history = useHistory();
    const location = useLocation();
    const [modalMarcasVisible, setModalMarcasVisible] = useState(false);
    const timerSearch = useRef(null)
    const error = useSelector(state => state.mainMetrico.error)
    const loading = useSelector(state => state.mainMetrico.loading)
    const message = useSelector(state => state.mainMetrico.message)
    const marcas = useSelector(state => state.mainMetrico.marcas)
    const secciones = useSelector(state => state.mainMetrico.secciones)
    const nameMarca = useSelector(state => state.mainMetrico.nameMarca)
    const nameUnidad = useSelector(state => state.mainMetrico.nameUnidad)

    const idMarca = useSelector(state => state.mainMetrico.idMarca)
    const idUnidad = useSelector(state => state.mainMetrico.idUnidad)
    
    const nameMetrico = useSelector(state => state.mainMetrico.nameMetrico)
    const descMetrico = useSelector(state => state.mainMetrico.descMetrico)
    const codeMetrico = useSelector(state => state.mainMetrico.codeMetrico)
    const hasData = useSelector(state => state.mainMetrico.hasData)

    const valMetrico = useSelector(state => state.mainMetrico.valMetrico)
    const formatMetrico = useSelector(state => state.mainMetrico.formatMetrico)

    const dataTable = useSelector(state => state.mainMetrico.dataTable)

    const data = useSelector(state => state.mainMetrico.data)


    const dispatch = useDispatch();

    useEffect(() => {
     dispatch(globalData()).then(()=>{
        dispatch(getMetrico())
     })
     return () => clearTimeout(timerSearch)
    },[]);




   function onChangeFilter(idMarca,idUnidad,nameMarca,nameUnidad)
   {
      dispatch(changeMarca(idMarca,idUnidad,nameMarca,nameUnidad))
      dispatch(getMetricosMenu(idMarca,idUnidad)).then(()=>{
        dispatch(getMetrico())
      })
      if(location.pathname==="/main/metrix/data")
      {
        history.goBack()
      }
      setModalMarcasVisible(false)

   }
    
   function onSelectMetrico(item)
   {   
      if(location.pathname!=="/main/metrix")
      {
        history.push("/main/metrix")
      } 
      
      dispatch(changeMetrico(item)).then(()=>{
        dispatch(getMetrico())
      })


   }
   
   function onSearch(value)
   {
     clearInterval(timerSearch.current)

     timerSearch.current = setTimeout(() => {
          dispatch(searchMetrico(value))
        }, 600)
   }
  
  function openDataTable()
  {   
     if (hasData!==0)
      {
        history.push("/main/metrix/data")
      }
      else
      {
        messageAntd.info('No existe información para este metrico');
      }
      
  }

  return (
        <Layout style={{ height: '100vh',overflowY:'scroll' }}> 
                           
            <SelectMarcas visible={modalMarcasVisible}  onCancel={()=>setModalMarcasVisible(false)} marcas={marcas} onChangeFilter={onChangeFilter}/>

            <Layout className="m-layout" >
           	    <Header className="m-header">
                    <div className="m-header-brand" onClick={()=>setModalMarcasVisible(true)}>
                          <div style={{lineHeight:"18px"}}>{nameMarca}<RightOutlined /></div>
                          <div style={{lineHeight:"16px",fontSize:"12px", fontWeight:100}}>{nameUnidad}
                          </div>
                          
  	                </div>
  	                <div className="m-header-content">
                          <Tooltip placement="bottom" color="blue" title={descMetrico}>
  	                        {nameMetrico} 
                              <InfoCircleOutlined style={{marginLeft:"10px"}}/>
                          </Tooltip>
  	                </div>
                    <div className="m-search">
                    <span className="m-icon-search">
                        <SearchOutlined/>
                    </span>
                    <input
                      style={{marginRight:"47px"}}
                      placeholder="Buscar métrico..."
                      type="search"
                      onChange={(e) => onSearch(e.target.value)}/> 
                  </div>
                </Header>
	            <Content className="m-content-background">
                  <Spin spinning={loading} tip="Loading..." indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>
	                <div style={{width:"100%",marginTop:"56px",
                              position: "sticky",
                              background:"#161C24",
                              top: "56px",zIndex:"1000"}}>
                  <MenuMetricos data={secciones} selectMetrico={onSelectMetrico}/>


                  </div>
                    <div className="m-content">
	                    <Switch>
	                        <Route path="/main/metrix/data" render={()=><TableMetrico nameMetrico={nameMetrico} valMetrico={valMetrico} formatMetrico={formatMetrico} idReporte={hasData} idMarca={idMarca} idUnidad={idUnidad}/>}/>
	                        <Route path="/main/metrix" render={() => <Metrico  data={data} openDataTable={openDataTable}/>}/>
	                    </Switch>
	                  </div>
                  </Spin>
	            </Content>
            </Layout>
        </Layout>
    );
}

export default MainMetrico;